@if (pickerType === 'circle') {
<ng-container *ngTemplateOutlet="circleColorPicker"></ng-container>
} @else {
<ng-container *ngTemplateOutlet="standardColorInput"></ng-container>
}
<ng-template #circleColorPicker>
  <div (click)="refreshColorPickerVariablesList($event)">
    <input
      class="picker cursor-pointer"
      [(colorPicker)]="color"
      [cpExtraTemplate]="cpVariableColours"
      (colorPickerSelect)="onChange($event, false)"
      [cpOKButton]="false"
      [cpEyeDropper]="true"
      [cpSaveClickOutside]="true"
      [cpOutputFormat]="'rgba'"
      [style.background]="selectedBackgroundColor"
      readonly
    />
  </div>
</ng-template>

<ng-template #cpVariableColours>
  <div class="">
    <h3>Global Colour Variables</h3>
  </div>

  <workflow-finx-dropdown
    class="no-padding"
    [options]="variableColorsList"
    [value]="variableColorList[selectedVariableIndex]?.value"
    (valueChange)="onChange($event, true)"
    [optionLabel]="'name'"
    [optionValue]="'value'"
    [closeOnBlur]="true"
  >
  </workflow-finx-dropdown>
</ng-template>

<ng-template #standardColorInput>
  <div class="color-picker-wrapper" (click)="refreshColorPickerVariablesList($event)">
    <input
      [(colorPicker)]="color"
      [cpExtraTemplate]="cpVariableColours"
      (colorPickerChange)="onChange($event, false)"
      [style.background]="selectedBackgroundColor"
      [cpEyeDropper]="true"
      [cpSaveClickOutside]="true"
      [cpOutputFormat]="'rgba'"
      readonly
    />
    <div class="color-picker-title typog-sm ellipsis-line-clamp">
      <ng-container *ngIf="selectedVarName; else hexColor">
        {{ selectedVarName }}
      </ng-container>
      <ng-template #hexColor>
        {{ selectedBackgroundColor | rgbaToHex }}
      </ng-template>
    </div>
  </div>
</ng-template>
